import { useSelector } from 'react-redux';
import { User } from 'new/entities/User';

type IsArray<T> = T extends Array<any> ? T : never;
type IsObject<T> = T extends { [id: number]: any } ? T : never;

export function useUsers<T extends boolean>(
  asObject?: T,
):
  | IsArray<T extends false ? Array<User> : never>
  | IsObject<T extends true ? { [id: number]: User } : never> {
  return useSelector((state: any) => {
    if (asObject) {
      return state.entities?.users;
    } else {
      return Object.values(state.entities?.users);
    }
  });
}
